import { useEffect } from 'react'

interface UsePopoverProps {
	ref: React.RefObject<HTMLElement>
	onClose?: () => void
}

export const usePopover = ({ ref, onClose }: UsePopoverProps): void => {
	useEffect(() => {
		const popoverEl = ref.current
		if (!popoverEl) return

		const onToggle = (event: Event): void => {
			// @ts-expect-error - newState is not typed - this is a valid event
			if (event.newState === 'closed') {
				onClose?.()
			}
		}

		popoverEl.addEventListener('toggle', onToggle)
		return () => popoverEl.removeEventListener('toggle', onToggle)
	}, [ref, onClose])
}
